/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")


  
    
export interface API50821Item {
  
  /** linkId */
  linkId?: number;
  
  /** 关联任务ID */
  taskId?: number;
  
  /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
  taskStatus?: number;
  
  /** 任务状态(1:未开始;2:进行中;3:已关闭;5:已完成) */
  taskStatusName?: string;
  
  /** 关联类型,默认link_task=关联，pre_task=前置任务 */
  linkType?: string;
  
  /** 关联类型,,@seecom.ywwl.foundation.teamwork.client.enums.LinkTypeEnum */
  linkTypeName?: string;
  
  /** 任务名称 */
  taskTitle?: string;
  
  /** 开始时间 */
  startTime?: any;
  
  /** 截止时间 */
  endTime?: any;
  
  /** 是否可删除 */
  canDelete?: number;
  
  /** 任务创建人发起人 */
  creator?: string;
  
  /** 用户状态,,@seecom.ywwl.foundation.teamwork.client.enums.UserStatusEnum */
  creatorStatus?: string;
  
  /** 任务发起者头像 */
  creatorLogo?: string;
  
  /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
  taskPriority?: number;
  
  /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
  taskPriorityName?: string;
  
};
    
  



export interface API50821Req {
  
  /** 任务id */
  taskId?: string;
    
  /** 查询关联任务=link，查询被关联任务=beLinked */
  queryLink?: string;
    
};



export interface API50821Res {
  /** T  */
  list?: API50821Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 50821 关联任务列表

export interface IUseGetAPI50821Return {
  /** 关联任务列表: 接口请求状态 */
  isAPI50821Loading: boolean;
  /** 关联任务列表: 接口请求返回数据 */
  dataAPI50821: API50821Res;
  /**  关联任务列表: 接口数据请求方法 */
  fetchAPI50821Data:  (inputs: API50821Req, config?: YWRequestConfig) => Promise<API50821Res>;
  /** 关联任务列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI50821 = ():IUseGetAPI50821Return => {
  let isMount = true;
  const [isAPI50821Loading, setIsAPI50821Loading] = useState(false);
  const [dataAPI50821, setDataAPI50821] = useState<API50821Res>({} as API50821Res);
  const requestUrl = `${basePath}/team-work/workTask/link/listLinkTask`;

  const fetchAPI50821Data = async (inputs: API50821Req, config?: YWRequestConfig): Promise<API50821Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API50821Req>) || {}) as API50821Req;
    
  
    if ( isMount ) {
      setIsAPI50821Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API50821Res>(`${basePath}/team-work/workTask/link/listLinkTask?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI50821(res || {} as API50821Res);
        setIsAPI50821Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI50821Loading(false);
      }
      return false as unknown as API50821Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI50821Loading,
    dataAPI50821,
    fetchAPI50821Data,
    requestUrl,
  }
}

